import oficina from "../../assets/oficina.svg";

const OficinasCFRL = ({
  cardData: {
    showCFCRLColec,
    altCFCRLColec,
    showCFCRLInd,
    altCFCRLInd,
    CFCRLIndividuals,
    CFCRLColectiva,
  },
}) => {
  return (
    <div className="row flex-column">
      <div className="col mb-3">
        <div className="row justify-content-center">
          <img src={oficina} alt="Oficinas de la CFRL" className="w-25" />
        </div>
      </div>
      <div className="col">
        {showCFCRLInd && CFCRLIndividuals ? (
          <>
            <h6 className="brief text-center">Asuntos individuales</h6>
            {CFCRLIndividuals.map(
              (
                {
                  admitidas,
                  total_conciliados,
                  total_no_conciliados,
                  total_tramite,
                  porcentaje_conciliacion,
                  total_conciliadores,
                  hombres,
                  mujeres,
                  total_notificadores,
                  hombres_notificadores,
                  mujeres_notificadoras,
                  sede,
                },
                i
              ) => (
                <div key={`${sede}-${i}`}>
                  <div>
                    <div className="row" key={i}>
                      <div className="col">
                        {/* Contenido de la primera columna */}
                        <div>
                          <h3
                            className="text-center brief title-card"
                            style={{ fontWeight: "900" }}
                          >
                            {admitidas}
                          </h3>
                        </div>
                        <div
                          className="text-center"
                          style={{ fontSize: "smaller" }}
                        >
                          Solicitudes admitidas
                        </div>
                      </div>
                      <div className="col">
                        {/* Contenido de la segunda columna */}
                        <div>
                          <h3
                            className="text-center brief title-card"
                            style={{ fontWeight: "900" }}
                          >
                            {total_tramite}
                          </h3>
                        </div>
                        <div
                          className="text-center"
                          style={{ fontSize: "smaller" }}
                        >
                          Asuntos en trámite
                        </div>
                      </div>
                      <div className="col">
                        {/* Contenido de la tercera columna */}
                        <div>
                          <h3
                            className="text-center brief title-card"
                            style={{ fontWeight: "900" }}
                          >
                            {total_conciliados}
                          </h3>
                        </div>
                        <div
                          className="text-center"
                          style={{ fontSize: "smaller" }}
                        >
                          Asuntos conciliados
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">
                        {/* Espacio vacío */}
                        <br></br>
                        <div>
                          <h3
                            className="text-center brief title-card"
                            style={{ fontWeight: "900" }}
                          >
                            {total_no_conciliados}
                          </h3>
                        </div>
                        <div
                          className="text-center"
                          style={{ fontSize: "smaller" }}
                        >
                          Asuntos no conciliados
                        </div>
                      </div>
                      <div className="col">
                        {/* Contenido para colocar debajo del espacio vacío */}
                      </div>
                      <div className="col">
                        {/* Otro contenido para colocar debajo del espacio vacío */}
                        <br></br>
                        <div>
                          <h3
                            className="text-center brief title-card"
                            style={{ fontWeight: "900" }}
                          >
                            {porcentaje_conciliacion}%
                          </h3>
                        </div>
                        <div
                          className="text-center"
                          style={{ fontSize: "smaller" }}
                        >
                          Tasa de conciliación
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">
                        {/* Espacio vacío */}
                        <br></br>
                        <div>
                          <h3
                            className="text-center brief title-card"
                            style={{ fontWeight: "900" }}
                          >
                            {total_conciliadores}
                            <span style={{ fontSize: "small" }}></span>
                          </h3>
                        </div>
                        <div
                          className="text-center"
                          style={{ fontSize: "smaller" }}
                        >
                          Número total de conciliadores
                        </div>
                      </div>
                      <div className="col">
                        {/* Contenido para colocar debajo del espacio vacío */}
                        <br></br>

                        <div>
                          <h3
                            className="text-center brief title-card"
                            style={{ fontWeight: "900" }}
                          >
                            {hombres}
                            <span style={{ fontSize: "small" }}></span>
                          </h3>
                        </div>
                        <div
                          className="text-center"
                          style={{ fontSize: "smaller" }}
                        >
                          Hombres
                        </div>
                      </div>
                      <div className="col">
                        {/* Otro contenido para colocar debajo del espacio vacío */}
                        <br></br>

                        <div>
                          <h3
                            className="text-center brief title-card"
                            style={{ fontWeight: "900" }}
                          >
                            {mujeres}
                            <span style={{ fontSize: "small" }}></span>
                          </h3>
                        </div>
                        <div
                          className="text-center"
                          style={{ fontSize: "smaller" }}
                        >
                          Mujeres
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">
                        {/* Espacio vacío */}
                        <br></br>
                        <div>
                          <h3
                            className="text-center brief title-card"
                            style={{ fontWeight: "900" }}
                          >
                            {total_notificadores}
                            <span style={{ fontSize: "small" }}></span>
                          </h3>
                        </div>
                        <div
                          className="text-center"
                          style={{ fontSize: "smaller" }}
                        >
                          Número total de Notificadores
                        </div>
                      </div>
                      <div className="col">
                        {/* Contenido para colocar debajo del espacio vacío */}
                        <br></br>

                        <div>
                          <h3
                            className="text-center brief title-card"
                            style={{ fontWeight: "900" }}
                          >
                            {hombres_notificadores}
                            <span style={{ fontSize: "small" }}></span>
                          </h3>
                        </div>
                        <div
                          className="text-center"
                          style={{ fontSize: "smaller" }}
                        >
                          Hombres
                        </div>
                      </div>
                      <div className="col">
                        {/* Otro contenido para colocar debajo del espacio vacío */}
                        <br></br>

                        <div>
                          <h3
                            className="text-center brief title-card"
                            style={{ fontWeight: "900" }}
                          >
                            {mujeres_notificadoras}
                            <span style={{ fontSize: "small" }}></span>
                          </h3>
                        </div>
                        <div
                          className="text-center"
                          style={{ fontSize: "smaller" }}
                        >
                          Mujeres
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )
            )}
          </>
        ) : (
          <div className="row flex-column">
            <div className="col"></div>
          </div>
        )}
        {showCFCRLColec && CFCRLColectiva ? (
  <>
    <h6 className='brief text-center mt-3'>Asuntos colectivos</h6>
    <div className='row justify-content-center'>
      <div className='col-md-4'>
        <div className='row flex-column justify-content-between align-items-center'>
          <div>
            <h3 className='text-center brief title-card' style={{ fontWeight: '900' }}>
              {CFCRLColectiva.admitidas}
            </h3>
          </div>
          <div className='text-center' style={{ fontSize: 'smaller' }}>
            Solicitudes admitidas
          </div>
        </div>
      </div>
      
      <div className='col-md-4'>
        <div className='row flex-column justify-content-between align-items-center'>
          <div>
            <h3 className='text-center brief title-card' style={{ fontWeight: '900' }}>
              {CFCRLColectiva.total_tramite}
            </h3>
          </div>
          <div className='text-center' style={{ fontSize: 'smaller' }}>
            Asuntos en trámite
          </div>
        </div>
      </div>
      
      <div className='col-md-4'>
        <div className='row flex-column justify-content-around align-items-center'>
          <div>
            <h3 className='text-center brief title-card' style={{ fontWeight: '900' }}>
              {CFCRLColectiva.total_conciliados}
            </h3>
          </div>
          <div className='text-center' style={{ fontSize: 'smaller' }}>
            Asuntos conciliados
          </div>
        </div>
        <br></br>
      </div>
    </div>
    <div className="row justify-content-center">
      {CFCRLColectiva.total_no_conciliados !== undefined && (
      <div className='col-md-6'>
        <div className='row flex-column align-items-center'>
          <div>
            <h3 className='text-center brief title-card' style={{ fontWeight: '900' }}>
              {CFCRLColectiva.total_no_conciliados}
            </h3>
          </div>
          <div className='text-center' style={{ fontSize: 'smaller' }}>
            Asuntos no conciliados
          </div>
        </div>
      </div>
      )}
      <div className='col-md-6'>
        <div className='row flex-column align-items-center'>
          <div>
            <h3 className='text-center brief title-card' style={{ fontWeight: '900' }}>
              {CFCRLColectiva.porcentaje_conciliacion}%
            </h3>
          </div>
          <div className='text-center' style={{ fontSize: 'smaller' }}>
            Tasa de conciliación
          </div>
        </div>
      </div>
      
    </div>
  </>
) : null}
      </div>
    </div>
  );
};

export default OficinasCFRL;
